export enum PageTab {
  Users = 'users',
  Entities = 'entities',
  Invitations = 'invitations',
  OnboardingTemplates = 'onboarding-templates',
  FirmOnboarding = 'firm-onboarding',
  SystemNotifications = 'system-notifications',
}
